import RectangleChart from 'src/components/RectangleChart/RectangleChart';
import { RectangleChartPoint, RectangleChartIconPoint } from 'src/components/RectangleChart/RectangleChart.types';
import RectangleChartIcon from 'src/components/RectangleChart/RectangleChartIcon';

export default RectangleChart;
export { RectangleChartIcon };
export type { RectangleChartPoint, RectangleChartIconPoint };
